import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Flex } from '@jutro/layout'
import cx from 'classnames'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import CoverageSummaryAccordion from '../CoverageSummaryAccordion/CoverageSummaryAccordion'
import styles from '../TWIABuildingSummaryAccordions/TWIABuildingSummaryAccordions.module.scss'
import metadata from './BuildingSummaryAccordion.metadata.json5';
import messages from './BuildingSummaryAccordion.messages';


function BuildingSummaryAccordion(props) {
    // US28766 and US28769
    const {   data: location, index, path: locationPath} = props;
    const translator = useContext(TranslatorContext)
    const intlContext = useContext(IntlContext);
  
    const buildingHeader = ( i,building,premium ) => {
        const formatterCurrency = intlContext.formatNumber(premium.amount, {
            style: 'currency',
            currency: premium.currency
        });
        return(
            <div>
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.BuildingTitle)}&nbsp;&nbsp;{_.get(building, 'buildingNumber.value')}</div>
                    <div className={cx(styles.heading, styles.flexOneThird)}>{_.get(building, 'description.value')}</div>
                    <div className={cx(styles.heading, styles.flexOneThird, styles.displayPremium)}>{formatterCurrency}</div>
                </Flex>
            </div>
        ) 
    }
   
    const generateTopicOverrides = useCallback(() => {
        const overrides = location.buildings.children.map((elt, i) => {
                return {
                    [`buildingCard${i}`]: {
                        title: buildingHeader( i+1,elt,elt.value.premium),
                    },
                }
            });

        return Object.assign({}, ...overrides);
    }, [ ]);

    const resolvers = {
        resolveCallbackMap: {
            buildingHeader
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            CoverageSummaryAccordion: CoverageSummaryAccordion,
        },
    }

    const overrideProps = {
        buildings: {
            data: location.buildings.children
        },
       
    
        ...generateTopicOverrides(),
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={location}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default BuildingSummaryAccordion